"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseFooterData = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
var _getChildrenWithNavigationType = require("./getChildrenWithNavigationType");
var _getFooterNavigationType = require("./getFooterNavigationType");
var _getPaymentMethods = require("./getPaymentMethods");
var _getSiteLinksColumns = require("./getSiteLinksColumns");
const parseFooterData = data => {
  const footer = (0, _getFooterNavigationType.getFooterNavigationType)(data);
  const bottom = (0, _getChildrenWithNavigationType.getChildrenWithNavigationType)(_staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.Bottom, footer);
  const paymentMethodsItems = (0, _getPaymentMethods.getPaymentMethods)(footer);
  const copyright = (0, _getChildrenWithNavigationType.getChildrenWithNavigationType)(_staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.BottomCopyright, bottom);
  const links = bottom?.children.filter(item => item.linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.BottomLinks).filter(link => Boolean(link.title)) ?? [];
  const siteLinksColumns = (0, _getSiteLinksColumns.getSiteLinksColumns)(footer);
  const ourApps = (0, _getChildrenWithNavigationType.getChildrenWithNavigationType)(_staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.OurApps, footer);
  const turkishException = (0, _getChildrenWithNavigationType.getChildrenWithNavigationType)(_staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.QRTR, footer);
  const languages = data.languages.map(value => ({
    code: value.code ?? '',
    name: value.name ?? '',
    type: value.type
  }));
  return {
    allPagesPagesContent: bottom?.description,
    frontpageContent: bottom?.title,
    paymentMethodsItems,
    copyrightTitle: copyright?.title,
    copyrightLinks: links,
    siteLinksColumns,
    ourApps,
    turkishException,
    languages,
    languageConfiguration: data.application?.footer?.languageConfiguration,
    socialMediaLinks: data.socialMediaLinks,
    newsletterSubsciptionConfiguration: data.newsletterSubsciptionConfiguration,
    mobileApps: data.mobileApps
  };
};
exports.parseFooterData = parseFooterData;
